import jsPDF from "jspdf";
import moment from "moment";
import {helpers} from "vuelidate/lib/validators";
import interventionReport from "../pages/InterventionReports/InterventionReport";


export default {
	install: function (Vue, options) {
		let pdf = {};

		Vue.mixin({
			mounted () {
				pdf.getX = (base, x) => {
					let p = x / 1600; // prendo la x in percentuale sui 1600
					return base.mm.width * p;
				};
				pdf.getY = (base, y) => {
					let p = y / 1600; // prendo la y in percentuale sui 1600
					return base.mm.height * p + 2.8; // prendo i 3 millimetri perchè la Y parte dal basso
				};
				pdf.getFont = (c) => {
					let size = 16;
					switch (c) {
						case 'big':
							size = 20;
							break;
						default:
					}
					return size;
				};
				pdf.toInt32 = (bytes) => {
					return (bytes[0] << 24) | (bytes[1] << 16) | (bytes[2] << 8) | bytes[3];
				};
				pdf.getDimensions = (data) => {
					return {
						width: pdf.toInt32(data.slice(16, 20)),
						height: pdf.toInt32(data.slice(20, 24))
					};
				};
				pdf.base64Decode = (data) => {
					let base64Characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
					var result = [];
					var current = 0;
					for (var i = 0, c; c = data.charAt(i); i++) {
						if (c === '=') {
							if (i !== data.length - 1 && (i !== data.length - 2 || data.charAt(i + 1) !== '=')) {
								throw new SyntaxError('Unexpected padding character.');
							}
							break;
						}
						var index = base64Characters.indexOf(c);
						if (index === -1) {
							throw new SyntaxError('Invalid Base64 character.');
						}
						current = (current << 6) | index;
						if (i % 4 === 3) {
							result.push(current >> 16, (current & 0xff00) >> 8, current & 0xff);
							current = 0;
						}
					}
					if (i % 4 === 1) {
						throw new SyntaxError('Invalid length for a Base64 string.');
					}
					if (i % 4 === 2) {
						result.push(current >> 4);
					} else if (i % 4 === 3) {
						current <<= 6;
						result.push(current >> 16, (current & 0xff00) >> 8);
					}
					return result;
				};
				pdf.getPngDimensions = (dataUri) => {
					return pdf.getDimensions(pdf.base64Decode(dataUri.substring(22)));
				};

				pdf.buildPdf = (structure, data, updateCallback) => {
					updateCallback('working');
					let a4 = {
						px: {
							width: 595,
							height: 842
						},
						mm: {
							width: 210,
							height: 297
						}
					};
					// inizializzo il documento
					let doc = new jsPDF({
						orientation: 'portrait',
						unit: 'mm',
						format: 'a4',
						compress: true
					});

					// elaboro la struttura con il documento
					let structurePdf = [];
					structure.map(str => {
						let showPage = (str.show === true) ? true : false;
						if (!showPage) {
							let checkShowPage = this.helpers.getObjectData(data, str.show);
							showPage = checkShowPage || false;
						}
						if (showPage) {
							let items = [];
							str.positions.map(p => {
								if (p.type == 'check') {
									if (_.isArray(p.x) && _.isArray(p.y)) {
										let checkValue = [1, 0, ""];
										for (let iPoint = 0; iPoint < p.x.length; iPoint++) {
											let value = this.helpers.getObjectData(data, p.key, p.type);
											value = (value == undefined) ? "" : value;
											value = (value == null) ? "" : value;
											let valueString = "";
											if (`_${checkValue[iPoint]}` == `_${value}`) {
												valueString = "X";
											}
											items.push({
												key: p.key,
												value: `${valueString}`,
												x: pdf.getX(a4, p.x[iPoint]),
												y: pdf.getY(a4, p.y[iPoint]),
												fs: pdf.getFont(p.class),
												mw: p.maxwidth
											});
										}
									} else {
										let value = this.helpers.getObjectData(data, p.key, p.type);
										value = (value == undefined) ? "" : value;
										value = (value == null) ? "" : value;
										let valueString = "";
										if (+value == 1) {
											valueString = "X";
										}
										items.push({
											key: p.key,
											value: `${valueString}`,
											x: pdf.getX(a4, p.x),
											y: pdf.getY(a4, p.y),
											fs: pdf.getFont(p.class),
											mw: p.maxwidth
										});
									}
								} else {
									if (p.type == 'products') {
										let products = this.helpers.getObjectData(data, p.key, p.type);
										products = JSON.parse(products);
										let y = p.y;

										products.map((pr, index) => {
											let x = p.x;
											['qta', 'cod', 'des'].map((k) => {
												items.push({
													key: `${p.key}_${index}_${k}`,
													value: products[index][k],
													x: pdf.getX(a4, x),
													y: pdf.getY(a4, y),
													fs: pdf.getFont(x, p.class),
													mw: p.maxwidth
												});
												if (k == 'qta') x += 190;
												if (k == 'cod') x += 300;
											});
											y += 27;
											y += p.yspace || 0;
										});

									} else {
										let value = null;
										if (p.key == 'sede.customer') {
											let i = this.helpers.getObjectData(data, "customer");
											if (i && i.agency) {
												value = i.agency;
											}
										} else {
											if (p.key == 'sede.vat_number') {
												let i = this.helpers.getObjectData(data, "customer");
												if (i && i.vat_number) {
													value = i.vat_number;
												}
											} else {
												value = this.helpers.getObjectData(data, p.key, p.type);
											}
										}
										value = (value == undefined) ? "" : value;
										value = (value == null) ? "" : value;
										if (p.type == "number") {
											if (+value && +value > 0) {
												value = +value;
											}
										}
										items.push({
											key: p.key,
											value: `${value}`,
											x: pdf.getX(a4, p.x),
											y: pdf.getY(a4, p.y),
											fs: pdf.getFont(p.class),
											mw: p.maxwidth
										});
									}

								}
							});
							str.items = items;
							structurePdf.push(str);
						}
					})

					let current_page = 0;

					structurePdf.reduce((accumulatorPromise, item) => {
						return accumulatorPromise.then(() => {
							return new Promise((resolve, reject) => {
								this.helpers.getDataUri(require(`@/assets/templates/${item.background}.jpg`), function (dataUri) {
									current_page++;
									// aggiungo lo sfondo
									doc.addImage(dataUri, 'JPEG', 0, 0, a4.mm.width, a4.mm.height);

									structurePdf[current_page - 1].items.map(i => {
										if (i.key == "signature") {
											let dimensions = pdf.getPngDimensions(i.value);
											if (i.value.trim() !== '')
												doc.addImage(i.value, 'PNG', i.x, i.y, pdf.getX(a4, dimensions.width), pdf.getY(a4, dimensions.height));
										} else {
											doc.setFontType('normal');
											doc.setFontSize(8);

											if (i.key == "code_type") {
												doc.setFontSize(9.5);
												const varN = {
													"service": "01554140226",
													"macchine": "04436400230"
												}
												doc.text(`${varN[i.value.toLowerCase()]}`, 25, 21.5, {
													maxWidth: a4.mm.width * (i.mw / 100)
												});
												doc.setFontSize(12);
												doc.setFontType('bold');
												i.value = `J. SCHNEEBERGER ${i.value.toUpperCase() || 'SERVICE'} ITALIA srl`;
											}
											// i.value = i.value.replace(/\<br\>/g, '. ');
											// i.value = i.value.replace(/\n/g, '. ');

											let a = i.value.split('\n');
											if (a.length > 1) {
												let h = i.y;
												a.map(atext => {
													atext = (atext.length == 0) ? " " : atext;
													let aTextNumRows = doc.splitTextToSize(atext, a4.mm.width * (i.mw / 100), {fontSize: 8}).length;
													let aTextDimension = doc.getTextDimensions(atext);
													// console.log(`H: ${h} - NumRows: ${aTextNumRows}`, atext);
													doc.text(atext, i.x, h, {
														maxWidth: a4.mm.width * (i.mw / 100)
													});
													h = h + ((aTextDimension['h'] + 0.3) * aTextNumRows);
												});
											} else {
												doc.text(i.value, i.x, i.y, {
													maxWidth: a4.mm.width * (i.mw / 100)
												});
											}


										}

									});

									// sono ancora in lavorazione (non ho finito le pagine da elaborare)
									if (current_page < structurePdf.length) {
										doc.addPage();
									}
									// sono alla fine.
									if (current_page == structurePdf.length) {
										doc.save(`report.pdf`);
										doc = null;
										updateCallback('end');
									}
									resolve();
								});
							});
						});
					}, Promise.resolve());

				};
			}
		});

		Vue.prototype.pdf = pdf;
	}
}
